import * as React from "react"
import { Container, Accordion, Card, useAccordionToggle } from "react-bootstrap";
import HTMLReactParser from 'html-react-parser';
import { Helmet } from "react-helmet"
import { useContext } from "react"
import AccordionContext from "react-bootstrap/AccordionContext"
import "./ServiceCards.scss"

// markup
const ServiceCards = (props) => {
    function CustomToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(eventKey, () =>
            eventKey,
            () => callback && callback(eventKey), 
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <div

                className="card-header"
                onClick={decoratedOnClick}
            >
                {children}
                <span><i className={isCurrentEventKey ? 'icon-show' : 'icon-plus'}> </i></span>
            </div>
        );
    }

     var faqschemaList = [];
       
            props.data.map((faqitem,i) =>{
                faqschemaList.push({
                    "@type": "Question",
                    "name": `${faqitem?.Title}`,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": `${faqitem?.Description}`
                    }
                })
            })
    

    return (
        <>
         <Helmet>
            <script type="application/ld+json">{`{
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": ${JSON.stringify(faqschemaList, null, 2)}
                }`}
          </script> 
       </Helmet>
        <React.Fragment>
            <section className="service-card sec-pdy-120">
                <Container>
                    {props?.SectionTitle ? <h4>{props?.SectionTitle}</h4> : <h4>Frequently Asked Questions</h4>}
                    <Accordion defaultActiveKey="5">
                        {props.data && props.data.map((card, i) => {
                            return (<Card>
                                <CustomToggle as={Card.Header} eventKey={i + 1} className="text-sm-bold"> <span className="text-sm-bold">{card.Title}</span>
                                </CustomToggle>

                                <Accordion.Collapse eventKey={i + 1}>
                                    <Card.Body className="text-sm">
                                        {HTMLReactParser(card.Description.replace(/\n/g, ''))}
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>)
                        })}
                    </Accordion>
                    {props?.cta_label && props?.cta_link && (
                        <div className="d-flex justify-content-start mt-5">
                            <a href={props.cta_link} className="btn btn-primary">
                                {props.cta_label}
                            </a>
                         </div>
                         )}

                </Container>
            </section>
        </React.Fragment>
        </>
    )
}
export default ServiceCards